import map from "lodash/map";
import { normalize } from 'normalizr';

import { getEndpoint, getHeaders } from "../../../helpers/endpoint";
import { receiveEntities } from "../../entities";
import { statisticListSchema } from "../../../schemas/statistic";

export const REQUEST_STATS_MPT_USERS = 'REQUEST_STATS_MPT_USERS';
export const SUCCESS_FETCH_STATS_MPT_USERS = 'SUCCESS_FETCH_STATS_MPT_USERS';
export const FAIL_FETCH_STATS_MPT_USERS = 'FAIL_FETCH_STATS_MPT_USERS';

export const fetchMPTUsersStatistics = (payload, scope) => {
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_STATS_MPT_USERS, payload, scope });

        fetch(getEndpoint('fetchStatsMptUsers'), {
            method: 'POST',
            headers: getHeaders(getState().authentication),
            body: JSON.stringify(payload)
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({ type: FAIL_FETCH_STATS_MPT_USERS });
            else dispatch(successFetchMPTUsersStatistics(data, payload, scope));
        })
            .catch((error, type = FAIL_FETCH_STATS_MPT_USERS) => { dispatch({ type, error, payload, scope }); });
    };
};

function successFetchMPTUsersStatistics(data, payload, scope) {
    return dispatch => {
        const { all, range } = data;
        const mppUsers = map({ ...range, all }, (stat, key) => {
            return { ...stat, id: `mptUsers-${key}`, date: key }
        });

        const normalized = normalize(mppUsers, statisticListSchema);
        normalized.result.splice(normalized.result.indexOf('mptUsers-all'), 1);

        dispatch(receiveEntities(normalized.entities));

        dispatch({
            type: SUCCESS_FETCH_STATS_MPT_USERS,
            receivedAt: Date.now(),
            ids: normalized.result,
            total: all,
            payload,
            scope
        });
    };
}

export const REQUEST_STATS_MPT_CARDS = 'REQUEST_STATS_MPT_CARDS';
export const SUCCESS_FETCH_STATS_MPT_CARDS = 'SUCCESS_FETCH_STATS_MPT_CARDS';
export const FAIL_FETCH_STATS_MPT_CARDS = 'FAIL_FETCH_STATS_MPT_CARDS';

export const fetchMPTCardsStatistics = (scope) => {
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_STATS_MPT_CARDS, scope });

        fetch(getEndpoint('fetchStatsMptCards'), {
            method: 'GET',
            headers: getHeaders(getState().authentication),
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({ type: FAIL_FETCH_STATS_MPT_CARDS });
            else dispatch(successFetchMPTCardsStatistics(data, scope));
        })
            .catch((error, type = FAIL_FETCH_STATS_MPT_CARDS) => { dispatch({ type, error, scope }); });
    };
};

function successFetchMPTCardsStatistics(data, scope) {
    return dispatch => {
        const { nbCardsByWeek, nbUserByWeek } = data;
        dispatch({
            type: SUCCESS_FETCH_STATS_MPT_CARDS,
            receivedAt: Date.now(),
            stats: {
                nbCardsByWeek,
                nbUserByWeek,
            },
            scope
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/entities/mpt/stats.js